var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F58C96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6243 0H34.374C38.7496 0 42.7919 2.33074 44.9766 6.11666L52.3576 18.8803C54.5423 22.6662 54.5423 27.3277 52.3576 31.1136L44.9827 43.8772C42.798 47.6631 38.7496 49.9938 34.3802 49.9938H19.6243C15.2488 49.9938 11.2065 47.6631 9.02181 43.8772L1.64695 31.1136C-0.537739 27.3277 -0.537739 22.6662 1.64695 18.8803L9.01564 6.11666C11.2065 2.33074 15.2488 0 19.6243 0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavo3);
export default __webpack_public_path__ + "static/media/favo-3.78d3832baf287ea7c1a9bd43a74e3c30.svg";
export { ForwardRef as ReactComponent };